import Api from 'Base/classes/Api';
import Dispatch from 'Base/classes/Dispatch';
import Auth from 'Base/classes/Auth';
import Quote from 'Base/classes/Quote';
import Conversion from 'Base/classes/Conversion';

export default ({id, workfield = null, professional = null}) => ({
    id: id,
    workfield: workfield,
    professional: professional,
    user: {
        email: null,
    },
    step: 1,
    steps: 4,
    stepNumber()
    {
        if ( isNaN(this.step) ) {
            return 4;
        }
        return this.step;
    },
    stepPercentage()
    {
        return 100 / this.steps * this.step;
    },
    previousStep()
    {
        if ( this.step == 2 ) {
            return this.step = 1;
        }

        if ( this.step == 3 ) {
            return this.step = 2;
        }

        if ( this.step == 4 ) {
            return this.step = 3;
        }

        if ( this.step == 'auth' ) {
            return this.step = 4;
        }
    },
    nextStep({detail})
    {
        console.log('Going to next step', detail, this.step);

        if ( detail.step == 1 ) {
            return this.step = 2;
        }

        if ( detail.step == 2 ) {
            return this.step = 3;
        }

        if ( detail.step == 3 ) {
            if (!this.user.id) {
                 this.step = 4;
                 return;
            }

            new Quote(this.id).user(this.user)
                .then(() => {
                    this.success();
                });
        }
        
        if ( detail.step == 4 ) {
            this.user = detail.user;
            
            if ( detail.exists ) {
                new Quote(this.id).userNotLogged({ user_id : detail.user_id}).then(() => {
                    if(detail.no_password) {
                        const url = new URL(window.location);
                        url.searchParams.set('no_password', true);
                        window.history.pushState({}, '', url);
                    }
                    this.success();
                }).catch((response) => {
                    this.errors.record(response.data.errors);
                });
                return;
            }
            this.register();
        }


    },
    authed(user)
    {         
        this.user = user;
    },
    requireConfirmedPhoneNumber()
    {
        return this.professional !== null;
    },
    success()
    {
        this.step = 'success';

        new Conversion().newQuote({quote: {
            id: this.id,
            direct: this.professional ? true : false
        }, professionalId: this.professional});
    },

    register()
    {
        new Auth().register(this.user)
            .then((response) => {
                new Quote(this.id).user(response.user)
                    .then(() => {
                        this.success();
                    }).catch((response) => {
                        this.errors.record(response.data.errors);
                    });
            })
            .catch((response) => {
                this.errors.record(response.data.errors);
            });
    },

    init() {
        new Auth().user()
            .then(({user}) => {
                this.authed(user);
                this.steps = 3;
            }).catch(() => {});
    }
});